export type Tomo = {
  label: string;
  title: string;
  subtitle: string;
  promise: string;
  cover: string;
  coverAlt: string;
  features: string[];
};

export const tomos: Tomo[] = [
  {
    label: 'TOMO I',
    title: 'Elixires de la Tierra',
    subtitle: 'El Recetario Maestro de Cosmética Natural y Alquimia de Ingredientes',
    promise: '20 recetas magistrales para fabricar, vender y transformar vidas con belleza consciente',
    cover: 'https://cdn.magicpatterns.com/uploads/gXwEdjpqwVPvh1qYSfhyqp/tomo1.png',
    coverAlt: 'Portada del Tomo I: Elixires de la Tierra, recetario de cosmética natural',
    features: [
      '20 recetas de cremas, sérums, elixires, tónicos, bálsamos y mascarillas premium',
      'Ingredientes actualizados a precios 2026 (sin cifras bajas tipo $300)',
      'Fundamentos de cosmética natural: ciencia + alquimia vibracional',
      'Solución de problemas: qué hacer si la crema no emulsiona o el sérum se oxida',
      'Programación lunar: cómo aprovechar los ciclos de la luna para potenciar tus productos',
      'Márgenes de ganancia reales: cuánto invertís y cuánto ganás por unidad',
      '60 páginas de contenido tácticamente organizado',
    ],
  },
  {
    label: 'TOMO II',
    title: 'Alquimia Financiera',
    subtitle: 'La Ingeniería de Precios, Costos y Rentabilidad en Argentina',
    promise: 'Domina la psicología de precios, márgenes de ganancia y escalabilidad sin trabajar más horas',
    cover: 'https://cdn.magicpatterns.com/uploads/4JUQYedaDKuh9phF1Las5A/tomo2.png',
    coverAlt: 'Portada del Tomo II: Alquimia Financiera, ingeniería de precios y rentabilidad',
    features: [
      'Cálculo de costos reales en Argentina (actualizado 2026, con inflación incluida)',
      'La psicología del precio: por qué cobrar premium no espanta clientes',
      'Márgenes maestros: de $15.000/mes a $150.000/mes sin trabajar más',
      'Costos ocultos: qué gastos olvidan todas las emprendedoras',
      'Impuestos y monotributo: cómo calcular sin perder dinero',
      'Estrategia de preventa: cómo vender antes de fabricar y mejorar tu flujo de caja',
      '60 páginas de ingeniería financiera real',
    ],
  },
  {
    label: 'TOMO III',
    title: 'Estética Magnética',
    subtitle: 'Branding, Fotografía, Diseño y Psicología del Consumidor Holístico',
    promise: 'La belleza vende 10x más cuando la presentás correctamente',
    cover: 'https://cdn.magicpatterns.com/uploads/4A1sRdimdW2sKK3LpxEBjN/tomo3.png',
    coverAlt: 'Portada del Tomo III: Estética Magnética, branding y dirección de arte',
    features: [
      'Branding desde cero: cómo crear una identidad visual que te diferencie',
      'Fotografía premium: trucos de iluminación y composición sin equipo caro',
      'Psicología del consumidor holístico: qué colores, qué palabras, qué energía vende',
      'Packaging que convence: antes de probar el producto, compran por la caja',
      'Storytelling consciente: cómo contar tu historia para que tus clientes se enamoren',
      'Estrategia de redes sociales 2026: qué publicar, cómo, y cuándo',
      '60 páginas de dirección de arte profesional',
    ],
  },
];

export type Bonus = {
  number: string;
  title: string;
  pages: string;
  description: string;
  cover: string;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Arquitectura de Abastecimiento Inteligente',
    pages: '11 páginas',
    description:
      'Sistema profesional para comprar insumos como una marca grande: auditoría de proveedores, negociación de precios mayoristas, cálculo real de costos y control de stock inteligente en Argentina 2026.',
    cover: 'https://cdn.magicpatterns.com/uploads/9XqXDiUBfPdzRYB5ffm335/bonus1.png',
  },
  {
    number: '02',
    title: 'La Fórmula del Margen Maestro',
    pages: '16 páginas',
    description:
      'Cálculo mental de rentabilidad sin planillas: la psicología de precios que te permite cobrar premium y que tus clientes amen pagarlo.',
    cover: 'https://cdn.magicpatterns.com/uploads/8uSi5ujgcf3s84rzTCw5qr/bonus2.png',
  },
  {
    number: '03',
    title: 'Rituales de Envasado',
    pages: '18 páginas',
    description:
      'Protocolos de limpieza energética y programación vibracional de cada lote: que cada frasco sea medicina y cada gota sea intención.',
    cover: 'https://cdn.magicpatterns.com/uploads/doHhkAsyVv2wHpdEcSzH7m/BONUS3.png',
  },
  {
    number: '04',
    title: 'Arquitectura de Etiquetas',
    pages: '22 páginas',
    description:
      'Guía de diseño persuasivo y legalidad: qué debe llevar tu etiqueta para generar confianza, vender más y cumplir con regulaciones.',
    cover: 'https://cdn.magicpatterns.com/uploads/oHARQXWQGGGXBXVfAJPjCH/bonus4.png',
  },
  {
    number: '05',
    title: 'Guiones de Venta Hipnótica',
    pages: '25 páginas',
    description:
      'Las palabras exactas para convertir consultas en compras: psicología de venta por WhatsApp, copy persuasivo y frases de cierre que funcionan.',
    cover: 'https://cdn.magicpatterns.com/uploads/kdUWaL7ToqKT2qeqSXfn2J/bonus5.png',
  },
  {
    number: '06',
    title: 'Oráculo de Contenidos Anual',
    pages: '30 páginas',
    description:
      '365 temas de posts para Instagram + calendario estratégico: un tema cada día, consistencia viral garantizada y algoritmo a tu favor.',
    cover: 'https://cdn.magicpatterns.com/uploads/gZ5qWzJMbwcCgx1VidCP6D/BONUS6.png',
  },
];
